// extracted by mini-css-extract-plugin
export default {"cartContainer":"RL","summarycontent":"SL","offset":"TL","leaf":"UL","summaryclosed":"VL","summaryheader":"WL","summaryitems":"XL","summaryprice":"YL","buttonopen":"ZL","buttondown":"aM","summaryfixed":"bM","usdnotification":"cM","renew":"eM","promowrapper":"fM","ordersummarywrap":"gM","simplewrap":"hM"};
    if(module.hot) {
      // 1715276859006
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  